import { render, staticRenderFns } from "./ib-button-toggle.vue?vue&type=template&id=5c8873f8&lang=pug&"
import script from "./ib-button-toggle.vue?vue&type=script&lang=js&"
export * from "./ib-button-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-button-toggle.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8873f8')) {
      api.createRecord('5c8873f8', component.options)
    } else {
      api.reload('5c8873f8', component.options)
    }
    module.hot.accept("./ib-button-toggle.vue?vue&type=template&id=5c8873f8&lang=pug&", function () {
      api.rerender('5c8873f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/ib-button-toggle.vue"
export default component.exports